export const LANGS = {
  ru: { label: 'Русский',  flag: '🇷🇺', short: 'RU' },
  uz: { label: "O'zbek",   flag: '🇺🇿', short: 'UZ' },
  en: { label: 'English',  flag: '🇬🇧', short: 'EN' },
};

const ru = {
  // nav
  'nav.home':     'Главная',
  'nav.game':     'Прогресс',
  'nav.balance':  'Кошелёк',
  'nav.business': 'Бизнес',
  'nav.profile':  'Профиль',

  // splash
  'splash.tagline': 'Зарабатывай, исследуя город',

  // language selector
  'lang.title':    'Выберите язык',
  'lang.subtitle': 'Choose your language · Tilni tanlang',
  'lang.continue': 'Продолжить',

  // onboarding
  'onboard.skip':        'Пропустить',
  'onboard.next':        'Далее',
  'onboard.select_mode': 'Выбрать режим',

  'onboard.slide1.title': 'Добро пожаловать\nв GeoEarn',
  'onboard.slide1.text':  'Зарабатывайте GEO-монеты, просто посещая любимые заведения. Реальные деньги за каждый визит.',
  'onboard.slide2.title': 'Как работает\nGEO Economy',
  'onboard.slide2.text':  'Сканируете QR — система проверяет геолокацию — GEO-монеты мгновенно зачисляются на кошелёк.',
  'onboard.slide3.title': 'Вывод\nна карту',
  'onboard.slide3.text':  'Конвертируйте GEO в сумы и выводите на Humo или Uzcard в любой момент. Без комиссии для пользователей.',

  'onboard.mode.title':      'Кто вы?',
  'onboard.mode.subtitle':   'Выберите режим использования GeoEarn',
  'onboard.mode.user.label': 'Geo Скаут',
  'onboard.mode.user.desc':  'Зарабатываю GEO-монеты, посещая заведения',
  'onboard.mode.biz.label':  'Бизнес',
  'onboard.mode.biz.desc':   'Управляю кампаниями и привлекаю клиентов',
  'onboard.mode.start':      'Начать',
  'onboard.mode.choose':     'Выберите режим',

  'onboard.legal.prefix':  'Нажимая «Начать», вы принимаете',
  'onboard.legal.terms':   'Условия пользования',
  'onboard.legal.and':     'и',
  'onboard.legal.privacy': 'Политику конфиденциальности',

  // scan button toasts
  'scan.update_tg':  'Обновите Telegram для сканирования QR',
  'scan.unavailable': 'Сканер недоступен в этой версии Telegram',
  'scan.aim':        'Наведите на QR-код заведения',
  'scan.use_tg':     'Системный сканер',

  // task labels
  'task.visit':    'Визит',
  'task.purchase': 'Покупка',
  'task.review':   'Отзыв',

  // home
  'home.title':          'Зарабатывайте GEO',
  'home.subtitle':       'Посещайте заведения и получайте GEO-монеты за каждый визит',
  'home.sorted':         'По расстоянию',
  'home.map':            'Карта',
  'home.campaigns':      'Активные кампании',
  'home.details':        'Подробнее',
  'home.close':          'Закрыть',
  'home.from_you':       'от вас',
  'home.terms':          'Условия пользования',
  'home.privacy':        'Конфиденциальность',
  'home.error.load':     'Не удалось загрузить предложения.',
  'home.error.title':    'Ошибка загрузки',
  'home.error.retry':    'Повторить',
  'home.empty.title':    'Нет активных кампаний',
  'home.empty.text':     'Пока нет заведений с активными акциями.\nЗагляните позже!',
  'home.reward':         'Вознаграждение',
  'home.task_type':      'Тип задания',
  'home.pin_required':   'Требуется PIN',
  'home.pin_hint':       'Попросите сотрудника назвать PIN при чекине',
  'home.how.title':      'Как это работает',
  'home.how.1':          'Нажмите сканер и наведите на QR-код',
  'home.how.2':          'Разрешите доступ к геолокации',
  'home.how.3':          'GEO-монеты зачислятся мгновенно',
  'home.sheet.how.1':    'Отсканируйте QR-код в заведении',
  'home.sheet.how.2':    'Разрешите доступ к геолокации',
  'home.sheet.how.3':    'GEO зачислятся мгновенно',

  // balance
  'balance.title':              'GEO Wallet',
  'balance.visits':             'Визитов',
  'balance.earned':             'Заработано',
  'balance.withdraw_cta':       'Вывести GEO → UZS',
  'balance.tab.activity':       'Активность',
  'balance.tab.withdrawals':    'Выводы',
  'balance.empty.visits.title': 'Нет активности',
  'balance.empty.visits.text':  'Сканируйте QR-коды в заведениях,\nчтобы получать GEO',
  'balance.empty.wd.title':     'Нет заявок',
  'balance.empty.wd.text':      'Заявки на вывод появятся здесь',
  'balance.error':              'Не удалось загрузить данные.',
  'balance.business':           'Заведение',
  'balance.wd.pending':         'Ожидает',
  'balance.wd.approved':        'Одобрено',
  'balance.wd.rejected':        'Отклонено',
  'balance.synced':             'Синхронизировано',
  'balance.total_balance':      'ОБЩИЙ БАЛАНС',
  'balance.btn.send':           'ВЫВЕСТИ',
  'balance.btn.history':        'ИСТОРИЯ',
  'balance.btn.rate':           'КУРС',
  'balance.tab.ledger':         'ОПЕРАЦИИ',
  'balance.tab.wd_label':       'ВЫВОДЫ',
  'balance.empty.tx':           'НЕТ ОПЕРАЦИЙ',
  'balance.err.title':          'ОШИБКА ЗАГРУЗКИ',
  'balance.tag.visit':          'Визит',

  // withdraw
  'withdraw.title':             'Вывод GEO',
  'withdraw.available':         'Доступно',
  'withdraw.card_label':        'Номер карты (Humo / Uzcard)',
  'withdraw.card_placeholder':  '0000 0000 0000 0000',
  'withdraw.card_hint':         '16 цифр — Humo или Uzcard',
  'withdraw.amount_label':      'Сумма (GEO)',
  'withdraw.min':               'Минимальная сумма',
  'withdraw.receive':           'Получите на карту',
  'withdraw.quick':             'Быстрый выбор',
  'withdraw.all':               'Всё',
  'withdraw.submit':            'Вывести GEO',
  'withdraw.submitting':        'Отправляем...',
  'withdraw.no_commission':     '1 GEO = {rate} UZS · без комиссии',
  'withdraw.success.title':     'Заявка принята!',
  'withdraw.success.debit':     'Спишется',
  'withdraw.success.card':      '= {uzs} UZS → на карту',
  'withdraw.success.time':      'Перевод на карту в течение 24 часов.',
  'withdraw.success.left':      'Остаток:',
  'withdraw.success.go':        'К кошельку',
  'withdraw.err.invalid_card':  'Введите корректный номер карты (16 цифр).',
  'withdraw.err.invalid_amount':'Введите корректную сумму.',
  'withdraw.err.below_min':     'Минимум вывода: {uzs} UZS ({geo} GEO)',
  'withdraw.err.over_max':      'Максимум: {geo} GEO',
  'withdraw.err.no_funds':      'Недостаточно GEO на балансе.',
  'withdraw.err.invalid_card2': 'Неверный номер карты. Введите 16 цифр.',
  'withdraw.err.general':       'Не удалось создать заявку. Попробуйте позже.',
  'withdraw.err.connection':    'Ошибка соединения. Попробуйте позже.',
  'withdraw.err.load':          'Не удалось загрузить баланс.',
  'withdraw.amount_ph':         'До {geo}',

  // profile
  'profile.support.title':      'Поддержка',
  'profile.support.open':       'Написать в поддержку',
  'profile.support.chat':       'Написать в поддержку',
  'profile.support.report':     'Сообщить о проблеме',

  // support sheet
  'support.title':              'Служба поддержки',
  'support.type.chat':          'Вопрос',
  'support.type.report':        'Жалоба',
  'support.placeholder':        'Опишите вашу проблему или вопрос...',
  'support.send':               'Отправить',
  'support.sending':            'Отправка...',
  'support.sent':               'Сообщение отправлено!',
  'support.sent_sub':           'Мы ответим вам в ближайшее время в этом чате.',
  'support.close':              'Закрыть',
  'support.err.short':          'Сообщение слишком короткое (минимум 3 символа)',
  'support.err.failed':         'Ошибка отправки. Попробуйте позже.',

  // checkin errors
  'err.TOO_FAR.title':             'Слишком далеко',
  'err.TOO_FAR.text':              'Подойдите ближе к заведению и попробуйте снова.',
  'err.TOO_SOON.title':            'Уже чекинились',
  'err.TOO_SOON.text':             'Вы недавно были в этом заведении. Возвращайтесь завтра!',
  'err.NO_ACTIVE_CAMPAIGN.title':  'Нет акции',
  'err.NO_ACTIVE_CAMPAIGN.text':   'В данный момент нет активных акций для этого заведения.',
  'err.INVALID_QR_TOKEN.title':    'Неверный QR',
  'err.INVALID_QR_TOKEN.text':     'QR-код недействителен. Попробуйте отсканировать заново.',
  'err.PIN_REQUIRED.title':        'Нужен PIN',
  'err.PIN_REQUIRED.text':         'Для этого заведения требуется PIN-код от сотрудника.',
  'err.INVALID_PIN.title':         'Неверный PIN',
  'err.INVALID_PIN.text':          'Введённый PIN-код неверен. Попросите сотрудника повторить.',
  'err.PIN_USED.title':            'PIN уже использован',
  'err.PIN_USED.text':             'Этот PIN уже использован. Попросите новый.',
  'err.PIN_EXPIRED.title':         'PIN устарел',
  'err.PIN_EXPIRED.text':          'Срок действия PIN истёк. Попросите сотрудника сгенерировать новый.',
  'err.NO_TOKEN.title':            'Нет токена',
  'err.NO_TOKEN.text':             'Откройте приложение через Telegram-бота или QR-код.',
  'err.UNKNOWN.title':             'Ошибка',
  'err.UNKNOWN.text':              'Не удалось загрузить акцию.',
  'err.NO_CONNECTION.title':       'Нет соединения',
  'err.NO_CONNECTION.text':        'Проверьте интернет и попробуйте снова.',

  'promo.NOT_FOUND.title':          'Промо не найдено',
  'promo.NOT_FOUND.text':           'QR-код недействителен или акция была удалена.',
  'promo.PROMO_INACTIVE.title':     'Акция приостановлена',
  'promo.PROMO_INACTIVE.text':      'Эта промо-акция временно недоступна.',
  'promo.PROMO_EXPIRED.title':      'Срок истёк',
  'promo.PROMO_EXPIRED.text':       'Эта промо-акция уже завершилась.',
  'promo.PROMO_EXHAUSTED.title':    'Все призы разобраны',
  'promo.PROMO_EXHAUSTED.text':     'К сожалению, все GEO по этой акции уже получены.',
  'promo.TOO_FAR.title':            'Слишком далеко',
  'promo.TOO_FAR.text':             'Подойдите ближе к точке на карте и попробуйте снова.',
  'promo.ALREADY_CLAIMED.title':    'Уже получено',
  'promo.ALREADY_CLAIMED.text':     'Вы уже получили награду по этой акции.',
  'promo.COOLDOWN.title':           'Подождите',
  'promo.COOLDOWN.text':            'Вы сможете получить эту награду снова позже.',
  'promo.DAILY_LIMIT_REACHED.title':'Дневной лимит',
  'promo.DAILY_LIMIT_REACHED.text': 'Вы достигли лимита промо-наград на сегодня (3/день).',
  'promo.USER_BANNED.title':        'Аккаунт заблокирован',
  'promo.USER_BANNED.text':         'Ваш аккаунт заблокирован.',

  // game levels
  'level.1':  'Новичок',
  'level.2':  'Исследователь',
  'level.3':  'Постоянный',
  'level.4':  'Активный',
  'level.5':  'Эксперт',
  'level.6':  'Мастер',
  'level.7':  'Ветеран',
  'level.8':  'Элита',
  'level.9':  'Чемпион',
  'level.10': 'Легенда',

  // checkin
  'checkin.loading':          'Загружаем акцию…',
  'checkin.submitting_biz':   'Отправляем чекин…',
  'checkin.submitting_promo': 'Получаем награду…',
  'checkin.wait':             'Подождите секунду…',
  'checkin.locating':         'Определяем местоположение…',
  'checkin.verifying':        'Проверяем данные…',
  'checkin.success_biz':      'Чекин выполнен!',
  'checkin.success_promo':    'Награда получена!',
  'checkin.received':         'Вы получили',
  'checkin.credited':         'GEO‑монеты зачислены на ваш кошелёк',
  'checkin.go_wallet':        'Перейти к кошельку',
  'checkin.go_home':          'Вернуться на главную',
  'checkin.pin.title':        'Введите PIN-код',
  'checkin.pin.ask':          'Попросите сотрудника назвать PIN-код',
  'checkin.pin.confirm':      'Подтвердить',
  'checkin.pin.reward':       'Вознаграждение:',
  'checkin.pin.min_digits':   'Введите PIN (4–6 цифр)',
  'checkin.geo_allow':        'Разрешить доступ к геолокации',
  'checkin.go_home_btn':      'На главную',

  'err.GEO_DENIED.title':      'Нет доступа к геолокации',
  'err.GEO_DENIED.text':       'Чекин невозможен без геолокации. Нажмите кнопку ниже — браузер запросит разрешение.',
  'err.GEO_DENIED_HARD.title': 'Доступ запрещён',
  'err.GEO_DENIED_HARD.text':  'Браузер заблокировал геолокацию.\n\nОткройте Настройки Telegram → Конфиденциальность → Геолокация и разрешите доступ, затем вернитесь.',

  // game
  'game.xp':         'Опыт (XP)',
  'game.xp_max':     'МАКС',
  'game.freeze':     'Заморозок: {n}',
  'game.xp_to_next': '+{xp} XP до L{lv}',
  'game.milestone':  'Юбилейный день! Бонус x1.5 к следующему чекину',

  // game page extras
  'hdr.balance':           'Баланс',
  'hdr.streak':            'Стрик',
  'hdr.tasks':             'Задачи',
  'hdr.tasks_done':        '★ {n} задач',
  'game.to_next_level':    'до {lv} уровня',
  'game.xp_left':          'ещё {xp} XP',
  'game.day.one':          'день',
  'game.day.few':          'дня',
  'game.day.many':         'дней',
  'game.claim_btn':        'Забрать',
  'game.claimable':        'Готово к получению: {n}',
  'game.group.daily':      'Ежедневные',
  'game.group.weekly':     'Еженедельные',
  'game.group.onetime':    'Разовые',
  'game.ach.progress':     '{earned} из {total} достижений',
  'game.ach.remaining':    'Осталось {n} наград',
  'game.ach.done':         'Все получены!',
  'game.ref.invited':      'Приглашено',
  'game.ref.active':       'Активных',
  'game.ref.geo':          'GEO',
  'game.ref.link_label':   'Реферальная ссылка',
  'game.ref.copy':         'Скопировать ссылку',
  'game.ref.copied':       'Скопировано!',
  'game.ref.how_title':    'Как это работает',
  'game.ref.step1':        '+25 GEO вам и +10 GEO другу после первого чекина',
  'game.ref.step2':        'Друг должен сделать чекин в течение 7 дней',
  'game.ref.step3':        'Бонус начисляется автоматически',
  'game.ref.step4':        '+5% от каждого чекина друга в течение 30 дней',
  'game.tab.tasks':        'Задания',
  'game.tab.achievements': 'Достижения',
  'game.tab.referral':     'Команда',
  'game.err.load':         'Не удалось загрузить данные',
  'game.err.claimed':      'Уже получено',
  'game.err.claim_fail':   'Не удалось получить',
  'game.err.connection':   'Ошибка соединения',

  // map page
  'map.title':           'Карта',
  'map.loading':         'Загружаем карту…',
  'map.nearby':          'Рядом с вами',
  'map.all_venues':      'Все заведения',
  'map.geo_unavailable': 'Геолокация недоступна',
  'map.empty.title':     'Нет кампаний на карте',
  'map.empty.text':      'Бизнесы ещё не привязали\nкоординаты к заведениям',
  'map.requires_pin':    'Требуется PIN от сотрудника',
  'map.place.one':       'место',
  'map.place.few':       'места',
  'map.place.many':      'мест',
  'map.camp.one':        'кампания',
  'map.camp.few':        'кампании',
  'map.camp.many':       'кампаний',

  // admin — tabs
  'admin.tab.overview':  'Обзор',
  'admin.tab.campaigns': 'Кампании',
  'admin.tab.topup':     'Пополнение',
  'admin.tab.qr':        'QR',

  // admin — top-up status
  'admin.status.pending':   'Ожидает',
  'admin.status.confirmed': 'Зачислено',
  'admin.status.rejected':  'Отклонено',

  // admin — campaign card
  'admin.campaign.active':    'Активна',
  'admin.campaign.finished':  'Завершена',
  'admin.campaign.stopped':   'Остановлена',
  'admin.campaign.stop':      'Стоп',
  'admin.campaign.per_task':  'GEO / задание',
  'admin.campaign.acts_of':   '{count} из {max} активаций',
  'admin.campaign.remaining': '{n} осталось',
  'admin.campaign.exhausted': 'Лимит исчерпан',
  'admin.campaign.card':      'Карточка',
  'admin.campaign.until':     'до {date}',

  // admin — detail modal
  'admin.modal.require_pin':     'Требует PIN',
  'admin.modal.budget':          'Бюджет: {amount} GEO',
  'admin.modal.qr_code':         'QR-код кампании',
  'admin.modal.sent':            'Отправлено',
  'admin.modal.to_telegram':     'В Telegram',
  'admin.modal.copied':          'Скопировано',
  'admin.modal.link':            'Ссылка',
  'admin.modal.activations':     'Активации',
  'admin.modal.remaining_label': 'Осталось:',
  'admin.modal.change':          'Изменить',
  'admin.modal.stop':            'Остановить',

  // admin — edit modal
  'admin.edit.title':       'Редактировать кампанию',
  'admin.edit.add_acts':    'Добавить активации',
  'admin.edit.cost':        'Стоимость: {geo} GEO',
  'admin.edit.no_balance':  '— недостаточно баланса',
  'admin.edit.ends_at':     'Дата окончания',
  'admin.edit.no_limit':    'Без ограничения',
  'admin.edit.err_balance': 'Недостаточно GEO на балансе.',
  'admin.edit.err_generic': 'Ошибка сохранения.',
  'admin.edit.saving':      'Сохраняем...',
  'admin.edit.save':        'Сохранить изменения',

  // admin — campaign form
  'admin.form.title':        'Новая кампания',
  'admin.form.balance':      'Баланс:',
  'admin.form.budget_label': 'Бюджет кампании (GEO)',
  'admin.form.budget_ph':    'Например: 50 000',
  'admin.form.visits_label': 'Количество активаций',
  'admin.form.visits_ph':    'Например: 100',
  'admin.form.pool':         'Пул наград',
  'admin.form.commission':   'Комиссия платформы 5%',
  'admin.form.total':        'Итого с вашего баланса',
  'admin.form.reward':       'Награда за задание',
  'admin.form.increase':     'Увеличьте бюджет или уменьшите активации',
  'admin.form.need_more':    'Недостаточно GEO — нужно ещё {geo} GEO',
  'admin.form.task_type':    'Тип задания',
  'admin.form.task_desc_ru':  'Описание задания (русский язык)',
  'admin.form.task_ph_ru':   'Что должен сделать клиент — на русском…',
  'admin.form.task_desc_uz':  'Описание задания (узбекский язык)',
  'admin.form.task_ph_uz':   'Что должен сделать клиент — на узбекском…',
  'admin.form.err_desc':     'Заполните описание на обоих языках.',
  'admin.form.end_date':     'Дата окончания (необязательно)',
  'admin.form.ends_on':      'Завершится {date}',
  'admin.form.require_pin':  'Требовать PIN',
  'admin.form.pin_hint':     'Сотрудник называет PIN клиенту',
  'admin.form.err_balance':  'Недостаточно GEO на балансе заведения.',
  'admin.form.err_reward':   'Увеличьте бюджет или уменьшите активации.',
  'admin.form.err_generic':  'Ошибка создания кампании.',
  'admin.form.creating':     'Создаём...',
  'admin.form.launch':       'Запустить · {geo} GEO / задание',

  // admin — payment modal
  'admin.payment.title':     'Оплата',
  'admin.payment.intro':     'Переведите {uzs} по реквизитам. После подтверждения зачислим {geo} GEO.',
  'admin.payment.bank':      'Банк',
  'admin.payment.recipient': 'Получатель',
  'admin.payment.comment':   'Комментарий',
  'admin.payment.card_no':   'Номер карты',
  'admin.payment.copy':      'Копировать',
  'admin.payment.notice':    'После оплаты GEO зачисляется в течение 24 часов. Укажите комментарий при переводе.',
  'admin.payment.paid':      'Я оплатил — ожидаю зачисления',

  // admin — overview tab
  'admin.overview.balance':        'GEO Баланс',
  'admin.overview.used':           'Использовано',
  'admin.overview.critical':       'Критически низкий баланс — пополните срочно',
  'admin.overview.warn':           'Остаток баланса менее 25% — пополните скоро',
  'admin.overview.forecast_prefix':'Хватит на',
  'admin.overview.no_traffic':     'Нет данных о трафике',
  'admin.overview.campaign':       'Кампания',
  'admin.overview.today':          'Сегодня',
  'admin.overview.visits':         'визитов',
  'admin.overview.week':           'За 7 дней',
  'admin.overview.vs_prev':        'vs прошлая',
  'admin.overview.geo_issued':     'GEO выдано',
  'admin.overview.all':            'всего',
  'admin.overview.active':         'Активная кампания',
  'admin.overview.acts_of':        '{count} из {max} активаций',
  'admin.overview.remaining':      '{n} осталось',
  'admin.overview.no_camps':       'Нет активных кампаний',

  // admin — campaigns tab
  'admin.camps.create':    'Создать кампанию',
  'admin.camps.all':       'Все кампании ({count})',
  'admin.camps.empty':     'Создайте первую кампанию',
  'admin.camps.pin_title': 'PIN для клиента',
  'admin.camps.pin_desc':  'Сгенерируйте одноразовый PIN и назовите его клиенту.',
  'admin.camps.pin_copied':'СКОПИРОВАНО',
  'admin.camps.pin_tap':   'НАЖМИТЕ ЧТОБЫ СКОПИРОВАТЬ',
  'admin.camps.pin_until': 'До {time} (15 мин)',
  'admin.camps.pin_new':   'Сгенерировать новый',
  'admin.camps.pin_create':'Создать PIN',
  'admin.camps.pin_gen':   'Генерируем...',

  // admin — top-up tab
  'admin.topup.balance':   'Текущий баланс',
  'admin.topup.forecast':  'Прогноз',
  'admin.topup.amount':    'Сумма пополнения',
  'admin.topup.unit':      'сум',
  'admin.topup.transfer':  'Сумма перевода',
  'admin.topup.before_fee':'GEO (до комиссии)',
  'admin.topup.fee':       'Комиссия 10%',
  'admin.topup.you_get':   'Вы получите',
  'admin.topup.acts_approx':'≈ {count} активаций кампании',
  'admin.topup.min':       'Минимальная сумма пополнения: 10 000 сум',
  'admin.topup.submitting':'Создаём заявку...',
  'admin.topup.btn':       'Пополнить — {uzs} сум',
  'admin.topup.enter':     'Введите сумму',
  'admin.topup.history':   'История пополнений',
  'admin.topup.empty':     'Пополнений пока нет',

  // admin — QR tab
  'admin.qr.hint':    'Разместите QR в заведении. Клиенты сканируют и получают GEO-бонусы при чекине.',
  'admin.qr.info':    'Информация о заведении',
  'admin.qr.name':    'Название',
  'admin.qr.address': 'Адрес',
  'admin.qr.balance': 'Баланс',

  // admin — root
  'admin.panel':          'Бизнес-панель',
  'admin.notowner.title': 'Панель бизнеса',
  'admin.notowner.text':  'Вы не зарегистрированы как владелец заведения.\n\nОбратитесь к администратору GeoEarn для подключения.',

  // plurals
  'admin.day.one':  'день',
  'admin.day.few':  'дня',
  'admin.day.many': 'дней',

  // TOS screen
  'tos.title':                   'Пользовательское соглашение',
  'tos.subtitle':                'Прочитайте ключевые условия перед использованием GeoEarn',
  'tos.point1':                  'Вы зарабатываете GEO за посещение заведений и участие в кампаниях.',
  'tos.point2':                  'Запрещено использовать ботов, подделывать GPS или создавать несколько аккаунтов.',
  'tos.point3':                  'GEO не являются ценными бумагами. Курс конвертации может меняться.',
  'tos.point4':                  'Мы собираем данные Telegram-аккаунта для авторизации и предотвращения мошенничества.',
  'tos.terms':                   'Условия использования',
  'tos.privacy':                 'Политика конфиденциальности',
  'tos.checkbox':                'Я прочитал(а) и принимаю Условия использования и Политику конфиденциальности GeoEarn',
  'tos.saving':                  'Сохраняем…',
  'tos.accept':                  'Принять и начать',
  'tos.version':                 'Версия соглашения: {v} · {year}',

  // Profile
  'profile.sa.sub':              'Панель управления',
  'profile.partner.title':       'Стать партнёром',
  'profile.partner.sub':         'Подать заявку на бизнес-аккаунт',

  // Browser gate
  'gate.text':                   'Это приложение работает только внутри Telegram.\nОткрой бота и отсканируй QR-код прямо там.',
  'gate.btn':                    'Открыть @geoearnbot',
  'gate.hint':                   'или найди @geoearnbot в поиске Telegram',

  // Business apply page
  'apply.title':                 'Стать партнёром',
  'apply.intro':                 'Заполните форму — мы рассмотрим заявку и свяжемся с вами через Telegram. После одобрения вы получите доступ к панели бизнеса и сможете создавать кампании.',
  'apply.success.title':         'Заявка отправлена!',
  'apply.success.sub':           'Мы уведомим вас в Telegram, когда заявка будет рассмотрена.',
  'apply.form.name':             'Название заведения',
  'apply.form.name_ph':          'Например: Кафе «Уют»',
  'apply.form.location':         'Местоположение',
  'apply.form.pick_map':         'Отметить на карте',
  'apply.form.address_label':    'Адрес (текстом)',
  'apply.form.address_ph':       'Заполняется автоматически или вручную',
  'apply.form.address_hint':     'Или введите адрес вручную',
  'apply.form.category':         'Категория',
  'apply.form.no_cat':           '— не выбрано —',
  'apply.form.phone':            'Контактный телефон',
  'apply.form.phone_hint':       'Для связи по вопросам заявки',
  'apply.form.submit':           'Отправить заявку',
  'apply.form.submitting':       'Отправляем…',
  'apply.err.name':              'Введите название заведения',
  'apply.err.owner':             'У вас уже есть бизнес-аккаунт',
  'apply.err.pending':           'Заявка уже отправлена и ожидает рассмотрения',
  'apply.err.generic':           'Ошибка при отправке заявки. Попробуйте ещё раз.',
  'apply.err.conn':              'Нет соединения. Попробуйте ещё раз.',
  'apply.reapply':               'Подать повторно',
  'apply.status.pending.title':  'Заявка на рассмотрении',
  'apply.status.pending.sub':    'Мы проверяем вашу заявку. Обычно это занимает 1–2 рабочих дня.',
  'apply.status.approved.title': 'Заявка одобрена!',
  'apply.status.approved.sub':   'Ваш бизнес-аккаунт активирован. Перейдите в раздел Бизнес.',
  'apply.status.rejected.title': 'Заявка отклонена',
  'apply.status.rejected.sub':   'Свяжитесь с поддержкой для уточнения причины.',
  'apply.status.info':           'Заявка №{id} · {date}',
  'apply.map.title':             'Отметьте место',
  'apply.map.hint':              'Нажмите на карту или перетащите метку',
  'apply.map.no_pos':            'Место не выбрано',
  'apply.map.geocoding':         'Определяем адрес…',
  'apply.map.confirm':           'Подтвердить место',
  'apply.cat.cafe':              'Кафе / Ресторан',
  'apply.cat.shop':              'Магазин',
  'apply.cat.pharmacy':          'Аптека',
  'apply.cat.beauty':            'Салон красоты',
  'apply.cat.gym':               'Спортзал / Фитнес',
  'apply.cat.auto':              'Автосервис',
  'apply.cat.other':             'Другое',

  // Checkin — geohunt & milestone
  'checkin.geohunt.found':       'GeoHunt найден!',
  'checkin.geohunt.activating':  'Активируем GeoHunt…',
  'checkin.geohunt.checking':    'Проверяем код…',
  'checkin.milestone.streak':    'ДНЕЙ ПОДРЯД',
  'checkin.milestone.bonus':     'Бонус за серию зачислен!',
  'checkin.milestone.continue':  'Продолжить',

  // Home extra
  'home.section.nearby':         'Рядом с вами',
  'home.no_camps_yet':           'Кампаний пока нет',
  'home.venues_soon':            'Заведения появятся, когда партнёры добавят их',
  'home.open_maps':              'Открыть в Google Картах',
  'home.load_err':               'Не удалось загрузить кампании',
  'home.retry':                  'Повторить',

  'home.platform_promo':     'Акция платформы',

  // GeoHunt sheet
  'home.hunt.reward_label':  'Награда за код',
  'home.hunt.progress':      'Прогресс',
  'home.hunt.remaining':     '{n} осталось',
  'home.hunt.all_found':     'Все найдены',
  'home.hunt.found_of':      '{found} из {total} найдено · {pct}%',
  'home.hunt.scanned_of':    '{found}/{total} отсканировано · {remaining} осталось',
  'home.hunt.find_on_map':   'Найти QR-коды на карте',
  'home.geo_per_code':       'GEO/шт',

  // Promo QR sheet
  'home.promo.availability': 'Доступность',
  'home.promo.available':    '{n} доступно',
  'home.promo.exhausted':    'Закончилось',
  'home.promo.claimed_of':   '{claimed} из {total} забрано',
  'home.promo.get_reward':   'Получить награду',
};

const uz = {
  'nav.home':     'Asosiy',
  'nav.game':     'Jarayon',
  'nav.balance':  'Hamyon',
  'nav.business': 'Biznes',
  'nav.profile':  'Profil',

  'splash.tagline': "Shaharni o'rganib daromad oling",

  'lang.title':    'Tilni tanlang',
  'lang.subtitle': 'Выберите язык · Choose your language',
  'lang.continue': 'Davom etish',

  'onboard.skip':        "O'tkazib yuborish",
  'onboard.next':        'Keyingi',
  'onboard.select_mode': "Rejimni tanlash",

  'onboard.slide1.title': "GeoEarn'ga\nxush kelibsiz",
  'onboard.slide1.text':  "Sevimli joylarga tashrif buyurib GEO tangalar ishlab oling. Har bir tashrif uchun haqiqiy pul.",
  'onboard.slide2.title': "GEO Economy\nnima?",
  'onboard.slide2.text':  "QR skanerlang — tizim geojoylashuvni tekshiradi — GEO tangalar darhol hamyonga o'tkaziladi.",
  'onboard.slide3.title': "Kartaga\npul chiqarish",
  'onboard.slide3.text':  "GEO ni so'mga o'zgartiring va Humo yoki Uzcard ga xohlagan payt chiqaring. Foydalanuvchilar uchun komissiyasiz.",

  'onboard.mode.title':      'Siz kimsiz?',
  'onboard.mode.subtitle':   "GeoEarn foydalanish rejimini tanlang",
  'onboard.mode.user.label': 'Geo Scout',
  'onboard.mode.user.desc':  "Joylarga tashrif buyurib GEO tangalar ishlab olaman",
  'onboard.mode.biz.label':  'Biznes',
  'onboard.mode.biz.desc':   "Kampaniyalarni boshqaraman va mijozlarni jalb qilaman",
  'onboard.mode.start':      'Boshlash',
  'onboard.mode.choose':     "Rejimni tanlang",

  'onboard.legal.prefix':  "«Boshlash» tugmasini bosib siz qabul qilasiz:",
  'onboard.legal.terms':   "Foydalanish shartlari",
  'onboard.legal.and':     'va',
  'onboard.legal.privacy': "Maxfiylik siyosati",

  'scan.update_tg':   "QR skanerlash uchun Telegram'ni yangilang",
  'scan.unavailable': "Skaner ushbu Telegram versiyasida mavjud emas",
  'scan.aim':         "Joy QR-kodiga yo'naltiring",
  'scan.use_tg':      'Tizim skaneri',

  'task.visit':    'Tashrif',
  'task.purchase': "Xarid",
  'task.review':   "Sharh",

  'home.title':          'GEO ishlab oling',
  'home.subtitle':       "Joylarga tashrif buyurib har bir tashrifda GEO tangalar oling",
  'home.sorted':         "Masofaga ko'ra",
  'home.map':            'Xarita',
  'home.campaigns':      "Faol kampaniyalar",
  'home.details':        "Batafsil",
  'home.close':          'Yopish',
  'home.from_you':       'sizdan',
  'home.terms':          "Foydalanish shartlari",
  'home.privacy':        "Maxfiylik",
  'home.error.load':     "Takliflarni yuklab bo'lmadi.",
  'home.error.title':    "Yuklab bo'lmadi",
  'home.error.retry':    "Qayta urinish",
  'home.empty.title':    "Faol kampaniyalar yo'q",
  'home.empty.text':     "Hozircha faol aksiyali joylar yo'q.\nKeyinroq qarang!",
  'home.reward':         "Mukofot",
  'home.task_type':      "Vazifa turi",
  'home.pin_required':   "PIN talab etiladi",
  'home.pin_hint':       "Check-in vaqtida xodimdan PIN so'rang",
  'home.how.title':      "Bu qanday ishlaydi",
  'home.how.1':          "Skaner tugmasini bosib QR-kodga yo'naltiring",
  'home.how.2':          "Geojoylashuvga ruxsat bering",
  'home.how.3':          "GEO tangalar darhol o'tkaziladi",
  'home.sheet.how.1':    "Joydagi QR-kodni skanerlang",
  'home.sheet.how.2':    "Geojoylashuvga ruxsat bering",
  'home.sheet.how.3':    "GEO darhol o'tkaziladi",

  'balance.title':              'GEO Hamyon',
  'balance.visits':             'Tashriflar',
  'balance.earned':             "Ishlab olingan",
  'balance.withdraw_cta':       'GEO → UZS chiqarish',
  'balance.tab.activity':       "Faoliyat",
  'balance.tab.withdrawals':    "Chiqarishlar",
  'balance.empty.visits.title': "Faoliyat yo'q",
  'balance.empty.visits.text':  "GEO olish uchun joylardagi\nQR-kodlarni skanerlang",
  'balance.empty.wd.title':     "Arizalar yo'q",
  'balance.empty.wd.text':      "Chiqarish arizalari shu yerda ko'rinadi",
  'balance.error':              "Ma'lumotlarni yuklab bo'lmadi.",
  'balance.business':           'Joy',
  'balance.wd.pending':         "Kutilmoqda",
  'balance.wd.approved':        "Tasdiqlangan",
  'balance.wd.rejected':        "Rad etilgan",
  'balance.synced':             'Sinxronlashtirildi',
  'balance.total_balance':      'UMUMIY BALANS',
  'balance.btn.send':           'CHIQARISH',
  'balance.btn.history':        'TARIX',
  'balance.btn.rate':           'KURS',
  'balance.tab.ledger':         'AMALLAR',
  'balance.tab.wd_label':       'CHIQARISHLAR',
  'balance.empty.tx':           "AMALLAR YO'Q",
  'balance.err.title':          'YUKLAB OLISH XATOSI',
  'balance.tag.visit':          'Tashrif',

  'withdraw.title':             'GEO chiqarish',
  'withdraw.available':         "Mavjud",
  'withdraw.card_label':        'Karta raqami (Humo / Uzcard)',
  'withdraw.card_placeholder':  '0000 0000 0000 0000',
  'withdraw.card_hint':         '16 ta raqam — Humo yoki Uzcard',
  'withdraw.amount_label':      "Miqdor (GEO)",
  'withdraw.min':               "Minimal miqdor",
  'withdraw.receive':           "Kartaga keladi",
  'withdraw.quick':             "Tez tanlash",
  'withdraw.all':               "Hammasi",
  'withdraw.submit':            'GEO chiqarish',
  'withdraw.submitting':        "Yuborilmoqda...",
  'withdraw.no_commission':     '1 GEO = {rate} UZS · komissiyasiz',
  'withdraw.success.title':     "Ariza qabul qilindi!",
  'withdraw.success.debit':     "Hisobdan chiqariladi",
  'withdraw.success.card':      '= {uzs} UZS → kartaga',
  'withdraw.success.time':      "24 soat ichida kartaga o'tkaziladi.",
  'withdraw.success.left':      "Qoldiq:",
  'withdraw.success.go':        "Hamyonga qaytish",
  'withdraw.err.invalid_card':  "To'g'ri karta raqamini kiriting (16 ta raqam).",
  'withdraw.err.invalid_amount':"To'g'ri miqdorni kiriting.",
  'withdraw.err.below_min':     "Minimal chiqarish: {uzs} UZS ({geo} GEO)",
  'withdraw.err.over_max':      "Maksimal: {geo} GEO",
  'withdraw.err.no_funds':      "Balansda yetarli GEO yo'q.",
  'withdraw.err.invalid_card2': "Noto'g'ri karta raqami. 16 ta raqam kiriting.",
  'withdraw.err.general':       "Ariza yaratib bo'lmadi. Keyinroq urinib ko'ring.",
  'withdraw.err.connection':    "Ulanish xatosi. Keyinroq urinib ko'ring.",
  'withdraw.err.load':          "Balansni yuklab bo'lmadi.",
  'withdraw.amount_ph':         '{geo} gacha',

  'profile.support.title':      'Yordam',
  'profile.support.open':       'Yordamga yozish',
  'profile.support.chat':       'Yordamga murojaat',
  'profile.support.report':     'Muammo haqida xabar berish',

  'support.title':              'Yordam xizmati',
  'support.type.chat':          'Savol',
  'support.type.report':        'Shikoyat',
  'support.placeholder':        'Muammoyingiz yoki savolingizni tasvirlab bering...',
  'support.send':               'Yuborish',
  'support.sending':            'Yuborilmoqda...',
  'support.sent':               'Xabar yuborildi!',
  'support.sent_sub':           'Yaqin orada shu chatda javob beramiz.',
  'support.close':              'Yopish',
  'support.err.short':          'Xabar juda qisqa (kamida 3 belgi)',
  'support.err.failed':         'Yuborishda xato. Keyinroq urinib koring.',

  'err.TOO_FAR.title':             "Juda uzoq",
  'err.TOO_FAR.text':              "Joyga yaqinroq boring va qayta urinib ko'ring.",
  'err.TOO_SOON.title':            "Allaqachon check-in qilgansiz",
  'err.TOO_SOON.text':             "Siz yaqinda bu joyda bo'lgansiz. Ertaga qaytib keling!",
  'err.NO_ACTIVE_CAMPAIGN.title':  "Aksiya yo'q",
  'err.NO_ACTIVE_CAMPAIGN.text':   "Hozirda bu joyda faol aksiyalar yo'q.",
  'err.INVALID_QR_TOKEN.title':    "Noto'g'ri QR",
  'err.INVALID_QR_TOKEN.text':     "QR-kod yaroqsiz. Qayta skanerlashga urinib ko'ring.",
  'err.PIN_REQUIRED.title':        "PIN kerak",
  'err.PIN_REQUIRED.text':         "Bu joy uchun xodimdan PIN-kod talab etiladi.",
  'err.INVALID_PIN.title':         "Noto'g'ri PIN",
  'err.INVALID_PIN.text':          "Kiritilgan PIN-kod noto'g'ri. Xodimdan qayta so'rang.",
  'err.PIN_USED.title':            "PIN allaqachon ishlatilgan",
  'err.PIN_USED.text':             "Bu PIN allaqachon ishlatilgan. Yangi PIN so'rang.",
  'err.PIN_EXPIRED.title':         "PIN muddati tugagan",
  'err.PIN_EXPIRED.text':          "PIN muddati tugagan. Xodimdan yangi PIN so'rang.",
  'err.NO_TOKEN.title':            "Token yo'q",
  'err.NO_TOKEN.text':             "Ilovani Telegram-bot yoki QR-kod orqali oching.",
  'err.UNKNOWN.title':             "Xato",
  'err.UNKNOWN.text':              "Aksiyani yuklab bo'lmadi.",
  'err.NO_CONNECTION.title':       "Internetga ulanish yo'q",
  'err.NO_CONNECTION.text':        "Internetni tekshiring va qayta urinib ko'ring.",

  'promo.NOT_FOUND.title':          "Promo topilmadi",
  'promo.NOT_FOUND.text':           "QR-kod yaroqsiz yoki aksiya o'chirilgan.",
  'promo.PROMO_INACTIVE.title':     "Aksiya to'xtatilgan",
  'promo.PROMO_INACTIVE.text':      "Bu promo-aksiya vaqtincha mavjud emas.",
  'promo.PROMO_EXPIRED.title':      "Muddati tugagan",
  'promo.PROMO_EXPIRED.text':       "Bu promo-aksiya tugadi.",
  'promo.PROMO_EXHAUSTED.title':    "Barcha mukofotlar olingan",
  'promo.PROMO_EXHAUSTED.text':     "Afsuski, bu aksiya bo'yicha barcha GEO allaqachon olingan.",
  'promo.TOO_FAR.title':            "Juda uzoq",
  'promo.TOO_FAR.text':             "Xaritadagi nuqtaga yaqinroq boring va qayta urinib ko'ring.",
  'promo.ALREADY_CLAIMED.title':    "Allaqachon olindi",
  'promo.ALREADY_CLAIMED.text':     "Siz bu aksiya bo'yicha mukofotni allaqachon oldingiz.",
  'promo.COOLDOWN.title':           "Kuting",
  'promo.COOLDOWN.text':            "Bu mukofotni keyinroq yana olishingiz mumkin.",
  'promo.DAILY_LIMIT_REACHED.title':"Kunlik limit",
  'promo.DAILY_LIMIT_REACHED.text': "Siz bugungi promo-mukofotlar limitiga yetdingiz (3/kun).",
  'promo.USER_BANNED.title':        "Hisob bloklangan",
  'promo.USER_BANNED.text':         "Sizning hisobingiz bloklangan.",

  'level.1':  'Yangi boshlovchi',
  'level.2':  "Izlovchi",
  'level.3':  "Doimiy",
  'level.4':  "Faol",
  'level.5':  "Ekspert",
  'level.6':  "Usta",
  'level.7':  "Veteran",
  'level.8':  "Elita",
  'level.9':  "Chempion",
  'level.10': "Legenda",

  'checkin.loading':          "Aksiyani yuklamoqda…",
  'checkin.submitting_biz':   "Check-in yuborilmoqda…",
  'checkin.submitting_promo': "Mukofot olinmoqda…",
  'checkin.wait':             "Bir daqiqa kuting…",
  'checkin.locating':         "Joylashuvingiz aniqlanmoqda…",
  'checkin.verifying':        "Ma'lumotlar tekshirilmoqda…",
  'checkin.success_biz':      "Check-in bajarildi!",
  'checkin.success_promo':    "Mukofot olindi!",
  'checkin.received':         "Siz oldingiz",
  'checkin.credited':         "GEO tangalar hamyoningizga o'tkazildi",
  'checkin.go_wallet':        "Hamyonga o'tish",
  'checkin.go_home':          "Asosiy sahifaga qaytish",
  'checkin.pin.title':        "PIN-kodni kiriting",
  'checkin.pin.ask':          "Xodimdan PIN-kodni so'rang",
  'checkin.pin.confirm':      "Tasdiqlash",
  'checkin.pin.reward':       "Mukofot:",
  'checkin.pin.min_digits':   "PIN kiriting (4–6 raqam)",
  'checkin.geo_allow':        "Geojoylashuvga ruxsat berish",
  'checkin.go_home_btn':      "Asosiy sahifa",

  'err.GEO_DENIED.title':      "Geojoylashuvga ruxsat yo'q",
  'err.GEO_DENIED.text':       "Geojoylashusiz check-in mumkin emas. Quyidagi tugmani bosing — brauzer ruxsat so'raydi.",
  'err.GEO_DENIED_HARD.title': "Kirish taqiqlangan",
  'err.GEO_DENIED_HARD.text':  "Brauzer geojoylashuvni bloklagan.\n\nTelegram Sozlamalar → Maxfiylik → Geojoylashuvni oching va ruxsat bering, keyin qaytib keling.",

  'game.xp':         'Tajriba (XP)',
  'game.xp_max':     'MAKS',
  'game.freeze':     'Muzlatish: {n}',
  'game.xp_to_next': '+{xp} XP L{lv} gacha',
  'game.milestone':  "Yubiley kuni! Keyingi check-inga x1.5 bonus",

  // game page extras
  'hdr.balance':           'Balans',
  'hdr.streak':            'Seriya',
  'hdr.tasks':             'Vazifalar',
  'hdr.tasks_done':        '★ {n} vazifa',
  'game.to_next_level':    '{lv} darajagacha',
  'game.xp_left':          'yana {xp} XP',
  'game.day.one':          'kun',
  'game.day.few':          'kun',
  'game.day.many':         'kun',
  'game.claim_btn':        'Olish',
  'game.claimable':        'Olishga tayyor: {n}',
  'game.group.daily':      'Kunlik',
  'game.group.weekly':     'Haftalik',
  'game.group.onetime':    'Bir martalik',
  'game.ach.progress':     '{earned} dan {total} ta yutuq',
  'game.ach.remaining':    '{n} ta qoldi',
  'game.ach.done':         'Barchasi olindi!',
  'game.ref.invited':      "Taklif qilingan",
  'game.ref.active':       'Faol',
  'game.ref.geo':          'GEO',
  'game.ref.link_label':   'Referal havola',
  'game.ref.copy':         'Havolani nusxalash',
  'game.ref.copied':       'Nusxalandi!',
  'game.ref.how_title':    "Bu qanday ishlaydi",
  'game.ref.step1':        "+25 GEO sizga va +10 GEO do'stga birinchi check-indan so'ng",
  'game.ref.step2':        "Do'st 7 kun ichida check-in qilishi kerak",
  'game.ref.step3':        "Bonus avtomatik ravishda o'tkaziladi",
  'game.ref.step4':        "30 kun davomida do'stning har bir check-inidan +5%",
  'game.tab.tasks':        'Vazifalar',
  'game.tab.achievements': 'Yutuqlar',
  'game.tab.referral':     'Jamoa',
  'game.err.load':         "Ma'lumotlarni yuklab bo'lmadi",
  'game.err.claimed':      'Allaqachon olindi',
  'game.err.claim_fail':   "Olib bo'lmadi",
  'game.err.connection':   'Ulanish xatosi',

  // map page
  'map.title':           'Xarita',
  'map.loading':         'Xarita yuklanmoqda…',
  'map.nearby':          'Sizga yaqin',
  'map.all_venues':      'Barcha joylar',
  'map.geo_unavailable': "Geolokatsiya mavjud emas",
  'map.empty.title':     "Xaritada kampaniyalar yo'q",
  'map.empty.text':      "Bizneslar hali koordinatalarni\njoylarga bog'lamagan",
  'map.requires_pin':    'Xodimdan PIN talab etiladi',
  'map.place.one':       'joy',
  'map.place.few':       'joy',
  'map.place.many':      'joy',
  'map.camp.one':        'kampaniya',
  'map.camp.few':        'kampaniya',
  'map.camp.many':       'kampaniya',

  'admin.tab.overview':  'Umumiy',
  'admin.tab.campaigns': 'Kampaniyalar',
  'admin.tab.topup':     "To'ldirish",
  'admin.tab.qr':        'QR',

  'admin.status.pending':   'Kutilmoqda',
  'admin.status.confirmed': 'Tasdiqlangan',
  'admin.status.rejected':  'Rad etilgan',

  'admin.campaign.active':    'Faol',
  'admin.campaign.finished':  'Tugagan',
  'admin.campaign.stopped':   "To'xtatilgan",
  'admin.campaign.stop':      "To'xtat",
  'admin.campaign.per_task':  'GEO / vazifa',
  'admin.campaign.acts_of':   '{count} dan {max} ta faollashtirish',
  'admin.campaign.remaining': '{n} qoldi',
  'admin.campaign.exhausted': 'Limit tugagan',
  'admin.campaign.card':      'Karta',
  'admin.campaign.until':     '{date} gacha',

  'admin.modal.require_pin':     'PIN talab etiladi',
  'admin.modal.budget':          'Byudjet: {amount} GEO',
  'admin.modal.qr_code':         'Kampaniya QR-kodi',
  'admin.modal.sent':            'Yuborildi',
  'admin.modal.to_telegram':     "Telegram'ga",
  'admin.modal.copied':          'Nusxalandi',
  'admin.modal.link':            'Havola',
  'admin.modal.activations':     'Faollashtirishlar',
  'admin.modal.remaining_label': 'Qoldi:',
  'admin.modal.change':          "O'zgartirish",
  'admin.modal.stop':            "To'xtatish",

  'admin.edit.title':       'Kampaniyani tahrirlash',
  'admin.edit.add_acts':    "Faollashtirish qo'shish",
  'admin.edit.cost':        'Narxi: {geo} GEO',
  'admin.edit.no_balance':  '— balans yetarli emas',
  'admin.edit.ends_at':     'Tugash sanasi',
  'admin.edit.no_limit':    'Cheksiz',
  'admin.edit.err_balance': 'Balansda GEO yetarli emas.',
  'admin.edit.err_generic': 'Saqlash xatosi.',
  'admin.edit.saving':      'Saqlanmoqda...',
  'admin.edit.save':        "O'zgarishlarni saqlash",

  'admin.form.title':        'Yangi kampaniya',
  'admin.form.balance':      'Balans:',
  'admin.form.budget_label': 'Kampaniya byudjeti (GEO)',
  'admin.form.budget_ph':    'Masalan: 50 000',
  'admin.form.visits_label': 'Faollashtirishlar soni',
  'admin.form.visits_ph':    'Masalan: 100',
  'admin.form.pool':         'Mukofot fondi',
  'admin.form.commission':   'Platforma komissiyasi 5%',
  'admin.form.total':        'Balansingizdan jami',
  'admin.form.reward':       'Vazifa uchun mukofot',
  'admin.form.increase':     'Byudjetni oshiring yoki faollashtirishlarni kamaytiring',
  'admin.form.need_more':    'GEO yetarli emas — yana {geo} GEO kerak',
  'admin.form.task_type':    'Vazifa turi',
  'admin.form.task_desc_ru':  'Vazifa tavsifi (rus tilida)',
  'admin.form.task_ph_ru':   'Mijoz nima qilishi kerak — rus tilida…',
  'admin.form.task_desc_uz':  "Vazifa tavsifi (o'zbek tilida)",
  'admin.form.task_ph_uz':   "Mijoz nima qilishi kerak — o'zbek tilida…",
  'admin.form.err_desc':     "Ikkala tilda tavsifni to'ldiring.",
  'admin.form.end_date':     'Tugash sanasi (ixtiyoriy)',
  'admin.form.ends_on':      '{date} da tugaydi',
  'admin.form.require_pin':  'PIN talab qilish',
  'admin.form.pin_hint':     'Xodim mijozga PIN aytadi',
  'admin.form.err_balance':  'Joy balansida GEO yetarli emas.',
  'admin.form.err_reward':   'Byudjetni oshiring yoki faollashtirishlarni kamaytiring.',
  'admin.form.err_generic':  'Kampaniya yaratishda xato.',
  'admin.form.creating':     'Yaratilmoqda...',
  'admin.form.launch':       'Ishga tushirish · {geo} GEO / vazifa',

  'admin.payment.title':     "To'lov",
  'admin.payment.intro':     "Rekvizitlar bo'yicha {uzs} o'tkazing. Tasdiqlangandan so'ng {geo} GEO yozamiz.",
  'admin.payment.bank':      'Bank',
  'admin.payment.recipient': 'Qabul qiluvchi',
  'admin.payment.comment':   'Izoh',
  'admin.payment.card_no':   'Karta raqami',
  'admin.payment.copy':      'Nusxalash',
  'admin.payment.notice':    "To'lovdan so'ng GEO 24 soat ichida yoziladi. O'tkazma izohini ko'rsating.",
  'admin.payment.paid':      "To'ladim — yozilishini kutaman",

  'admin.overview.balance':        'GEO Balansi',
  'admin.overview.used':           'Ishlatilgan',
  'admin.overview.critical':       "Kritik past balans — tezda to'ldiring",
  'admin.overview.warn':           "Balansning 25% dan kam qoldi — tez orada to'ldiring",
  'admin.overview.forecast_prefix':"Yetadi",
  'admin.overview.no_traffic':     "Trafik ma'lumoti yo'q",
  'admin.overview.campaign':       'Kampaniya',
  'admin.overview.today':          'Bugun',
  'admin.overview.visits':         'tashrif',
  'admin.overview.week':           '7 kunda',
  'admin.overview.vs_prev':        'oldingi',
  'admin.overview.geo_issued':     'GEO berildi',
  'admin.overview.all':            'jami',
  'admin.overview.active':         'Faol kampaniya',
  'admin.overview.acts_of':        '{count} dan {max} ta faollashtirish',
  'admin.overview.remaining':      '{n} qoldi',
  'admin.overview.no_camps':       "Faol kampaniyalar yo'q",

  'admin.camps.create':    'Kampaniya yaratish',
  'admin.camps.all':       'Barcha kampaniyalar ({count})',
  'admin.camps.empty':     'Birinchi kampaniyani yarating',
  'admin.camps.pin_title': 'Mijoz uchun PIN',
  'admin.camps.pin_desc':  'Bir martalik PIN yarating va mijozga ayting.',
  'admin.camps.pin_copied':'NUSXALANDI',
  'admin.camps.pin_tap':   'NUSXALASH UCHUN BOSING',
  'admin.camps.pin_until': '{time} gacha (15 daq)',
  'admin.camps.pin_new':   'Yangi yaratish',
  'admin.camps.pin_create':'PIN yaratish',
  'admin.camps.pin_gen':   'Yaratilmoqda...',

  'admin.topup.balance':    'Joriy balans',
  'admin.topup.forecast':   'Prognoz',
  'admin.topup.amount':     "To'ldirish summasi",
  'admin.topup.unit':       "so'm",
  'admin.topup.transfer':   "O'tkazma summasi",
  'admin.topup.before_fee': 'GEO (komissiyasiz)',
  'admin.topup.fee':        'Komissiya 10%',
  'admin.topup.you_get':    'Siz olasiz',
  'admin.topup.acts_approx':"≈ {count} ta kampaniya faollashtirishi",
  'admin.topup.min':        "Minimal to'ldirish: 10 000 so'm",
  'admin.topup.submitting': 'Ariza yaratilmoqda...',
  'admin.topup.btn':        "To'ldirish — {uzs} so'm",
  'admin.topup.enter':      'Summa kiriting',
  'admin.topup.history':    "To'ldirish tarixi",
  'admin.topup.empty':      "To'ldirishlar yo'q",

  'admin.qr.hint':    'QR ni joyga joylashtiring. Mijozlar skanerlaydi va check-inda GEO-bonus oladi.',
  'admin.qr.info':    "Joy haqida ma'lumot",
  'admin.qr.name':    'Nomi',
  'admin.qr.address': 'Manzili',
  'admin.qr.balance': 'Balans',

  'admin.panel':          'Biznes-panel',
  'admin.notowner.title': 'Biznes paneli',
  'admin.notowner.text':  "Siz joy egasi sifatida ro'yxatdan o'tmagansiz.\n\nUlanish uchun GeoEarn administratoriga murojaat qiling.",

  'admin.day.one':  'kun',
  'admin.day.few':  'kun',
  'admin.day.many': 'kun',

  // TOS screen
  'tos.title':                   "Foydalanuvchi shartnomasi",
  'tos.subtitle':                "GeoEarn'dan foydalanishdan oldin asosiy shartlarni o'qing",
  'tos.point1':                  "Joylarga tashrif buyurib va kampaniyalarda ishtirok etib GEO ishlab olasiz.",
  'tos.point2':                  "Botlardan foydalanish, GPS'ni soxtalashtirish yoki bir nechta hisob yaratish taqiqlanadi.",
  'tos.point3':                  "GEO qimmatli qog'ozlar emas. Konvertatsiya kursi o'zgarishi mumkin.",
  'tos.point4':                  "Biz Telegram hisobingiz ma'lumotlarini avtorizatsiya va firibgarlikni oldini olish uchun yig'amiz.",
  'tos.terms':                   "Foydalanish shartlari",
  'tos.privacy':                 "Maxfiylik siyosati",
  'tos.checkbox':                "Men GeoEarn Foydalanish shartlari va Maxfiylik siyosatini o'qidim va qabul qilaman",
  'tos.saving':                  "Saqlanmoqda…",
  'tos.accept':                  "Qabul qilish va boshlash",
  'tos.version':                 "Shartnoma versiyasi: {v} · {year}",

  // Profile
  'profile.sa.sub':              "Boshqaruv paneli",
  'profile.partner.title':       "Hamkor bo'lish",
  'profile.partner.sub':         "Biznes hisob uchun ariza berish",

  // Browser gate
  'gate.text':                   "Bu ilova faqat Telegram ichida ishlaydi.\nBotni oching va QR-kodni shu yerda skanerlang.",
  'gate.btn':                    "@geoearnbot'ni ochish",
  'gate.hint':                   "yoki Telegram qidiruvida @geoearnbot'ni toping",

  // Business apply page
  'apply.title':                 "Hamkor bo'lish",
  'apply.intro':                 "Anketani to'ldiring — arizangizni ko'rib chiqamiz va Telegram orqali siz bilan bog'lanamiz. Tasdiqlangandan so'ng siz biznes paneliga kirish va kampaniyalar yaratish imkoniyatiga ega bo'lasiz.",
  'apply.success.title':         "Ariza yuborildi!",
  'apply.success.sub':           "Ariza ko'rib chiqilganda Telegram orqali xabardor qilamiz.",
  'apply.form.name':             "Joy nomi",
  'apply.form.name_ph':          "Masalan: «Shinam» kafe",
  'apply.form.location':         "Joylashuv",
  'apply.form.pick_map':         "Xaritada belgilash",
  'apply.form.address_label':    "Manzil (matn)",
  'apply.form.address_ph':       "Avtomatik to'ldiriladi yoki qo'lda kiriting",
  'apply.form.address_hint':     "Yoki manzilni qo'lda kiriting",
  'apply.form.category':         "Toifa",
  'apply.form.no_cat':           "— tanlanmagan —",
  'apply.form.phone':            "Aloqa telefoni",
  'apply.form.phone_hint':       "Ariza bo'yicha muloqot uchun",
  'apply.form.submit':           "Ariza yuborish",
  'apply.form.submitting':       "Yuborilmoqda…",
  'apply.err.name':              "Joy nomini kiriting",
  'apply.err.owner':             "Sizda allaqachon biznes hisob bor",
  'apply.err.pending':           "Ariza allaqachon yuborilgan va ko'rib chiqilmoqda",
  'apply.err.generic':           "Ariza yuborishda xato. Qayta urinib ko'ring.",
  'apply.err.conn':              "Ulanish yo'q. Qayta urinib ko'ring.",
  'apply.reapply':               "Qayta ariza berish",
  'apply.status.pending.title':  "Ariza ko'rib chiqilmoqda",
  'apply.status.pending.sub':    "Arizangizni tekshirayapmiz. Odatda 1–2 ish kuni davom etadi.",
  'apply.status.approved.title': "Ariza tasdiqlandi!",
  'apply.status.approved.sub':   "Biznes hisobingiz faollashtirildi. Biznes bo'limiga o'ting.",
  'apply.status.rejected.title': "Ariza rad etildi",
  'apply.status.rejected.sub':   "Sabab haqida bilib olish uchun qo'llab-quvvatlash bilan bog'laning.",
  'apply.status.info':           "Ariza №{id} · {date}",
  'apply.map.title':             "Joyni belgilang",
  'apply.map.hint':              "Xaritaga bosing yoki markerni sudrang",
  'apply.map.no_pos':            "Joy tanlanmagan",
  'apply.map.geocoding':         "Manzil aniqlanmoqda…",
  'apply.map.confirm':           "Joyni tasdiqlash",
  'apply.cat.cafe':              "Kafe / Restoran",
  'apply.cat.shop':              "Do'kon",
  'apply.cat.pharmacy':          "Dorixona",
  'apply.cat.beauty':            "Go'zallik saloni",
  'apply.cat.gym':               "Sport zal / Fitnes",
  'apply.cat.auto':              "Avtoservis",
  'apply.cat.other':             "Boshqa",

  // Checkin — geohunt & milestone
  'checkin.geohunt.found':       "GeoHunt topildi!",
  'checkin.geohunt.activating':  "GeoHunt faollashtirilmoqda…",
  'checkin.geohunt.checking':    "Kod tekshirilmoqda…",
  'checkin.milestone.streak':    "KUN KETMA-KET",
  'checkin.milestone.bonus':     "Ketma-ketlik bonusi yozildi!",
  'checkin.milestone.continue':  "Davom etish",

  // Home extra
  'home.section.nearby':         "Sizga yaqin",
  'home.no_camps_yet':           "Kampaniyalar hozircha yo'q",
  'home.venues_soon':            "Bizneslar joy qo'shganda ko'rinadi",
  'home.open_maps':              "Google Xaritada ochish",
  'home.load_err':               "Kampaniyalarni yuklab bo'lmadi",
  'home.retry':                  "Qayta urinish",

  'home.platform_promo':     'Platforma aksiyasi',

  // GeoHunt sheet
  'home.hunt.reward_label':  'Kod uchun mukofot',
  'home.hunt.progress':      'Jarayon',
  'home.hunt.remaining':     '{n} qoldi',
  'home.hunt.all_found':     'Barchasi topildi',
  'home.hunt.found_of':      '{found}/{total} topildi · {pct}%',
  'home.hunt.scanned_of':    '{found}/{total} skanerlandi · {remaining} qoldi',
  'home.hunt.find_on_map':   "Xaritada QR-kodlarni topish",
  'home.geo_per_code':       'GEO/ta',

  // Promo QR sheet
  'home.promo.availability': 'Mavjudlik',
  'home.promo.available':    '{n} mavjud',
  'home.promo.exhausted':    'Tugadi',
  'home.promo.claimed_of':   '{claimed}/{total} olindi',
  'home.promo.get_reward':   'Mukofot olish',
};

const en = {
  'nav.home':     'Home',
  'nav.game':     'Progress',
  'nav.balance':  'Wallet',
  'nav.business': 'Business',
  'nav.profile':  'Profile',

  'splash.tagline': 'Earn while exploring the city',

  'lang.title':    'Choose Language',
  'lang.subtitle': 'Выберите язык · Tilni tanlang',
  'lang.continue': 'Continue',

  'onboard.skip':        'Skip',
  'onboard.next':        'Next',
  'onboard.select_mode': 'Choose Mode',

  'onboard.slide1.title': 'Welcome to\nGeoEarn',
  'onboard.slide1.text':  'Earn GEO coins by visiting your favorite places. Real money for every check-in.',
  'onboard.slide2.title': 'How GEO Economy\nWorks',
  'onboard.slide2.text':  'Scan QR — system verifies geolocation — GEO coins are instantly credited to your wallet.',
  'onboard.slide3.title': 'Withdraw\nto Card',
  'onboard.slide3.text':  'Convert GEO to UZS and withdraw to Humo or Uzcard anytime. No fees for users.',

  'onboard.mode.title':      'Who are you?',
  'onboard.mode.subtitle':   'Choose your GeoEarn mode',
  'onboard.mode.user.label': 'Geo Scout',
  'onboard.mode.user.desc':  'I earn GEO coins by visiting places',
  'onboard.mode.biz.label':  'Business',
  'onboard.mode.biz.desc':   'I manage campaigns and attract customers',
  'onboard.mode.start':      'Get Started',
  'onboard.mode.choose':     'Choose Mode',

  'onboard.legal.prefix':  'By tapping «Get Started», you agree to',
  'onboard.legal.terms':   'Terms of Service',
  'onboard.legal.and':     'and',
  'onboard.legal.privacy': 'Privacy Policy',

  'scan.update_tg':   'Update Telegram to scan QR',
  'scan.unavailable': 'Scanner unavailable in this Telegram version',
  'scan.aim':         'Aim at the venue QR code',
  'scan.use_tg':      'System scanner',

  'task.visit':    'Visit',
  'task.purchase': 'Purchase',
  'task.review':   'Review',

  'home.title':          'Earn GEO',
  'home.subtitle':       'Visit places and earn GEO coins for every check-in',
  'home.sorted':         'By distance',
  'home.map':            'Map',
  'home.campaigns':      'Active campaigns',
  'home.details':        'Details',
  'home.close':          'Close',
  'home.from_you':       'from you',
  'home.terms':          'Terms of Service',
  'home.privacy':        'Privacy',
  'home.error.load':     'Failed to load offers.',
  'home.error.title':    'Load error',
  'home.error.retry':    'Retry',
  'home.empty.title':    'No active campaigns',
  'home.empty.text':     'No venues with active offers yet.\nCheck back later!',
  'home.reward':         'Reward',
  'home.task_type':      'Task type',
  'home.pin_required':   'PIN required',
  'home.pin_hint':       'Ask a staff member for the PIN when checking in',
  'home.how.title':      'How it works',
  'home.how.1':          'Tap the scanner and aim at the QR code',
  'home.how.2':          'Allow access to geolocation',
  'home.how.3':          'GEO coins are credited instantly',
  'home.sheet.how.1':    'Scan the QR code at the venue',
  'home.sheet.how.2':    'Allow access to geolocation',
  'home.sheet.how.3':    'GEO is credited instantly',

  'balance.title':              'GEO Wallet',
  'balance.visits':             'Visits',
  'balance.earned':             'Earned',
  'balance.withdraw_cta':       'Withdraw GEO → UZS',
  'balance.tab.activity':       'Activity',
  'balance.tab.withdrawals':    'Withdrawals',
  'balance.empty.visits.title': 'No activity',
  'balance.empty.visits.text':  'Scan QR codes at venues\nto earn GEO',
  'balance.empty.wd.title':     'No requests',
  'balance.empty.wd.text':      'Withdrawal requests will appear here',
  'balance.error':              'Failed to load data.',
  'balance.business':           'Venue',
  'balance.wd.pending':         'Pending',
  'balance.wd.approved':        'Approved',
  'balance.wd.rejected':        'Rejected',
  'balance.synced':             'Synced',
  'balance.total_balance':      'TOTAL BALANCE',
  'balance.btn.send':           'SEND',
  'balance.btn.history':        'HISTORY',
  'balance.btn.rate':           'RATE',
  'balance.tab.ledger':         'LEDGER',
  'balance.tab.wd_label':       'WITHDRAWALS',
  'balance.empty.tx':           'NO TRANSACTIONS',
  'balance.err.title':          'LOAD ERROR',
  'balance.tag.visit':          'Visit',

  'withdraw.title':             'Withdraw GEO',
  'withdraw.available':         'Available',
  'withdraw.card_label':        'Card number (Humo / Uzcard)',
  'withdraw.card_placeholder':  '0000 0000 0000 0000',
  'withdraw.card_hint':         '16 digits — Humo or Uzcard',
  'withdraw.amount_label':      'Amount (GEO)',
  'withdraw.min':               'Minimum amount',
  'withdraw.receive':           'You will receive',
  'withdraw.quick':             'Quick select',
  'withdraw.all':               'All',
  'withdraw.submit':            'Withdraw GEO',
  'withdraw.submitting':        'Submitting...',
  'withdraw.no_commission':     '1 GEO = {rate} UZS · no fees',
  'withdraw.success.title':     'Request accepted!',
  'withdraw.success.debit':     'Will be deducted',
  'withdraw.success.card':      '= {uzs} UZS → to card',
  'withdraw.success.time':      'Transfer to card within 24 hours.',
  'withdraw.success.left':      'Balance:',
  'withdraw.success.go':        'To wallet',
  'withdraw.err.invalid_card':  'Please enter a valid card number (16 digits).',
  'withdraw.err.invalid_amount':'Please enter a valid amount.',
  'withdraw.err.below_min':     'Minimum withdrawal: {uzs} UZS ({geo} GEO)',
  'withdraw.err.over_max':      'Maximum: {geo} GEO',
  'withdraw.err.no_funds':      'Insufficient GEO balance.',
  'withdraw.err.invalid_card2': 'Invalid card number. Enter 16 digits.',
  'withdraw.err.general':       'Failed to create request. Try again later.',
  'withdraw.err.connection':    'Connection error. Try again later.',
  'withdraw.err.load':          'Failed to load balance.',
  'withdraw.amount_ph':         'Up to {geo}',

  'profile.support.title':      'Support',
  'profile.support.open':       'Contact Support',
  'profile.support.chat':       'Contact Support',
  'profile.support.report':     'Report an Issue',

  'support.title':              'Support',
  'support.type.chat':          'Question',
  'support.type.report':        'Report',
  'support.placeholder':        'Describe your issue or question...',
  'support.send':               'Send',
  'support.sending':            'Sending...',
  'support.sent':               'Message sent!',
  'support.sent_sub':           'We will reply to you shortly in this chat.',
  'support.close':              'Close',
  'support.err.short':          'Message too short (minimum 3 characters)',
  'support.err.failed':         'Failed to send. Please try again later.',

  'err.TOO_FAR.title':             'Too far away',
  'err.TOO_FAR.text':              'Get closer to the venue and try again.',
  'err.TOO_SOON.title':            'Already checked in',
  'err.TOO_SOON.text':             'You were here recently. Come back tomorrow!',
  'err.NO_ACTIVE_CAMPAIGN.title':  'No active offer',
  'err.NO_ACTIVE_CAMPAIGN.text':   'There are no active offers for this venue right now.',
  'err.INVALID_QR_TOKEN.title':    'Invalid QR',
  'err.INVALID_QR_TOKEN.text':     'QR code is invalid. Try scanning again.',
  'err.PIN_REQUIRED.title':        'PIN required',
  'err.PIN_REQUIRED.text':         'A PIN code from staff is required for this venue.',
  'err.INVALID_PIN.title':         'Wrong PIN',
  'err.INVALID_PIN.text':          'The PIN you entered is incorrect. Ask staff to repeat it.',
  'err.PIN_USED.title':            'PIN already used',
  'err.PIN_USED.text':             'This PIN has already been used. Ask for a new one.',
  'err.PIN_EXPIRED.title':         'PIN expired',
  'err.PIN_EXPIRED.text':          'The PIN has expired. Ask staff to generate a new one.',
  'err.NO_TOKEN.title':            'No token',
  'err.NO_TOKEN.text':             'Open the app via the Telegram bot or QR code.',
  'err.UNKNOWN.title':             'Error',
  'err.UNKNOWN.text':              'Failed to load the offer.',
  'err.NO_CONNECTION.title':       'No connection',
  'err.NO_CONNECTION.text':        'Check your internet connection and try again.',

  'promo.NOT_FOUND.title':          'Promo not found',
  'promo.NOT_FOUND.text':           'QR code is invalid or the offer was deleted.',
  'promo.PROMO_INACTIVE.title':     'Offer paused',
  'promo.PROMO_INACTIVE.text':      'This promo offer is temporarily unavailable.',
  'promo.PROMO_EXPIRED.title':      'Expired',
  'promo.PROMO_EXPIRED.text':       'This promo offer has ended.',
  'promo.PROMO_EXHAUSTED.title':    'All prizes claimed',
  'promo.PROMO_EXHAUSTED.text':     'Unfortunately, all GEO for this offer have been claimed.',
  'promo.TOO_FAR.title':            'Too far away',
  'promo.TOO_FAR.text':             'Get closer to the point on the map and try again.',
  'promo.ALREADY_CLAIMED.title':    'Already claimed',
  'promo.ALREADY_CLAIMED.text':     'You have already claimed the reward for this offer.',
  'promo.COOLDOWN.title':           'Please wait',
  'promo.COOLDOWN.text':            'You can claim this reward again later.',
  'promo.DAILY_LIMIT_REACHED.title':'Daily limit reached',
  'promo.DAILY_LIMIT_REACHED.text': 'You have reached the daily promo limit (3/day).',
  'promo.USER_BANNED.title':        'Account banned',
  'promo.USER_BANNED.text':         'Your account has been banned.',

  'level.1':  'Novice',
  'level.2':  'Explorer',
  'level.3':  'Regular',
  'level.4':  'Active',
  'level.5':  'Expert',
  'level.6':  'Master',
  'level.7':  'Veteran',
  'level.8':  'Elite',
  'level.9':  'Champion',
  'level.10': 'Legend',

  'checkin.loading':          'Loading offer…',
  'checkin.submitting_biz':   'Submitting check-in…',
  'checkin.submitting_promo': 'Claiming reward…',
  'checkin.wait':             'Please wait…',
  'checkin.locating':         'Detecting location…',
  'checkin.verifying':        'Verifying data…',
  'checkin.success_biz':      'Check-in complete!',
  'checkin.success_promo':    'Reward claimed!',
  'checkin.received':         'You received',
  'checkin.credited':         'GEO coins credited to your wallet',
  'checkin.go_wallet':        'Go to wallet',
  'checkin.go_home':          'Back to home',
  'checkin.pin.title':        'Enter PIN code',
  'checkin.pin.ask':          'Ask a staff member for the PIN code',
  'checkin.pin.confirm':      'Confirm',
  'checkin.pin.reward':       'Reward:',
  'checkin.pin.min_digits':   'Enter PIN (4–6 digits)',
  'checkin.geo_allow':        'Allow location access',
  'checkin.go_home_btn':      'Home',

  'err.GEO_DENIED.title':      'Location access denied',
  'err.GEO_DENIED.text':       'Check-in requires location access. Tap the button below to request permission.',
  'err.GEO_DENIED_HARD.title': 'Location blocked',
  'err.GEO_DENIED_HARD.text':  'Your browser has blocked location access.\n\nOpen Telegram Settings → Privacy → Location and allow access, then return.',

  'game.xp':         'Experience (XP)',
  'game.xp_max':     'MAX',
  'game.freeze':     'Freezes: {n}',
  'game.xp_to_next': '+{xp} XP to L{lv}',
  'game.milestone':  'Milestone day! x1.5 bonus on next check-in',

  // game page extras
  'hdr.balance':           'Balance',
  'hdr.streak':            'Streak',
  'hdr.tasks':             'Tasks',
  'hdr.tasks_done':        '★ {n} tasks',
  'game.to_next_level':    'to level {lv}',
  'game.xp_left':          '{xp} XP left',
  'game.day.one':          'day',
  'game.day.few':          'days',
  'game.day.many':         'days',
  'game.claim_btn':        'Claim',
  'game.claimable':        'Ready to claim: {n}',
  'game.group.daily':      'Daily',
  'game.group.weekly':     'Weekly',
  'game.group.onetime':    'One-time',
  'game.ach.progress':     '{earned} of {total} achievements',
  'game.ach.remaining':    '{n} rewards left',
  'game.ach.done':         'All unlocked!',
  'game.ref.invited':      'Invited',
  'game.ref.active':       'Active',
  'game.ref.geo':          'GEO',
  'game.ref.link_label':   'Referral link',
  'game.ref.copy':         'Copy link',
  'game.ref.copied':       'Copied!',
  'game.ref.how_title':    'How it works',
  'game.ref.step1':        '+25 GEO for you and +10 GEO for friend after their first check-in',
  'game.ref.step2':        'Friend must check in within 7 days',
  'game.ref.step3':        'Bonus is credited automatically',
  'game.ref.step4':        '+5% of every friend check-in for 30 days',
  'game.tab.tasks':        'Tasks',
  'game.tab.achievements': 'Achievements',
  'game.tab.referral':     'Team',
  'game.err.load':         'Failed to load data',
  'game.err.claimed':      'Already claimed',
  'game.err.claim_fail':   'Failed to claim',
  'game.err.connection':   'Connection error',

  // map page
  'map.title':           'Map',
  'map.loading':         'Loading map…',
  'map.nearby':          'Near you',
  'map.all_venues':      'All venues',
  'map.geo_unavailable': 'Location unavailable',
  'map.empty.title':     'No campaigns on map',
  'map.empty.text':      "Businesses haven't added\ncoordinates to their venues yet",
  'map.requires_pin':    'Staff PIN required',
  'map.place.one':       'venue',
  'map.place.few':       'venues',
  'map.place.many':      'venues',
  'map.camp.one':        'campaign',
  'map.camp.few':        'campaigns',
  'map.camp.many':       'campaigns',

  'admin.tab.overview':  'Overview',
  'admin.tab.campaigns': 'Campaigns',
  'admin.tab.topup':     'Top-up',
  'admin.tab.qr':        'QR',

  'admin.status.pending':   'Pending',
  'admin.status.confirmed': 'Credited',
  'admin.status.rejected':  'Rejected',

  'admin.campaign.active':    'Active',
  'admin.campaign.finished':  'Finished',
  'admin.campaign.stopped':   'Stopped',
  'admin.campaign.stop':      'Stop',
  'admin.campaign.per_task':  'GEO / task',
  'admin.campaign.acts_of':   '{count} of {max} activations',
  'admin.campaign.remaining': '{n} remaining',
  'admin.campaign.exhausted': 'Limit reached',
  'admin.campaign.card':      'Details',
  'admin.campaign.until':     'until {date}',

  'admin.modal.require_pin':     'Requires PIN',
  'admin.modal.budget':          'Budget: {amount} GEO',
  'admin.modal.qr_code':         'Campaign QR code',
  'admin.modal.sent':            'Sent',
  'admin.modal.to_telegram':     'To Telegram',
  'admin.modal.copied':          'Copied',
  'admin.modal.link':            'Link',
  'admin.modal.activations':     'Activations',
  'admin.modal.remaining_label': 'Remaining:',
  'admin.modal.change':          'Edit',
  'admin.modal.stop':            'Stop',

  'admin.edit.title':       'Edit campaign',
  'admin.edit.add_acts':    'Add activations',
  'admin.edit.cost':        'Cost: {geo} GEO',
  'admin.edit.no_balance':  '— insufficient balance',
  'admin.edit.ends_at':     'End date',
  'admin.edit.no_limit':    'No limit',
  'admin.edit.err_balance': 'Insufficient GEO balance.',
  'admin.edit.err_generic': 'Save error.',
  'admin.edit.saving':      'Saving...',
  'admin.edit.save':        'Save changes',

  'admin.form.title':        'New campaign',
  'admin.form.balance':      'Balance:',
  'admin.form.budget_label': 'Campaign budget (GEO)',
  'admin.form.budget_ph':    'e.g. 50 000',
  'admin.form.visits_label': 'Number of activations',
  'admin.form.visits_ph':    'e.g. 100',
  'admin.form.pool':         'Reward pool',
  'admin.form.commission':   'Platform fee 5%',
  'admin.form.total':        'Total from your balance',
  'admin.form.reward':       'Reward per task',
  'admin.form.increase':     'Increase budget or reduce activations',
  'admin.form.need_more':    'Insufficient GEO — need {geo} more GEO',
  'admin.form.task_type':    'Task type',
  'admin.form.task_desc_ru':  'Task description (Russian)',
  'admin.form.task_ph_ru':   'What must the customer do — in Russian…',
  'admin.form.task_desc_uz':  'Task description (Uzbek)',
  'admin.form.task_ph_uz':   'What must the customer do — in Uzbek…',
  'admin.form.err_desc':     'Fill in description in both languages.',
  'admin.form.end_date':     'End date (optional)',
  'admin.form.ends_on':      'Ends on {date}',
  'admin.form.require_pin':  'Require PIN',
  'admin.form.pin_hint':     'Staff tells PIN to customer',
  'admin.form.err_balance':  'Insufficient GEO balance at venue.',
  'admin.form.err_reward':   'Increase budget or reduce activations.',
  'admin.form.err_generic':  'Failed to create campaign.',
  'admin.form.creating':     'Creating...',
  'admin.form.launch':       'Launch · {geo} GEO / task',

  'admin.payment.title':     'Payment',
  'admin.payment.intro':     "Transfer {uzs} via the details below. After confirmation we'll credit {geo} GEO.",
  'admin.payment.bank':      'Bank',
  'admin.payment.recipient': 'Recipient',
  'admin.payment.comment':   'Comment',
  'admin.payment.card_no':   'Card number',
  'admin.payment.copy':      'Copy',
  'admin.payment.notice':    'After payment, GEO is credited within 24 hours. Include the comment in your transfer.',
  'admin.payment.paid':      'I paid — awaiting credit',

  'admin.overview.balance':        'GEO Balance',
  'admin.overview.used':           'Used',
  'admin.overview.critical':       'Critically low balance — top up now',
  'admin.overview.warn':           'Balance below 25% — top up soon',
  'admin.overview.forecast_prefix':'Enough for',
  'admin.overview.no_traffic':     'No traffic data',
  'admin.overview.campaign':       'Campaign',
  'admin.overview.today':          'Today',
  'admin.overview.visits':         'visits',
  'admin.overview.week':           '7 days',
  'admin.overview.vs_prev':        'vs prev',
  'admin.overview.geo_issued':     'GEO issued',
  'admin.overview.all':            'total',
  'admin.overview.active':         'Active campaign',
  'admin.overview.acts_of':        '{count} of {max} activations',
  'admin.overview.remaining':      '{n} remaining',
  'admin.overview.no_camps':       'No active campaigns',

  'admin.camps.create':    'Create campaign',
  'admin.camps.all':       'All campaigns ({count})',
  'admin.camps.empty':     'Create your first campaign',
  'admin.camps.pin_title': 'Customer PIN',
  'admin.camps.pin_desc':  'Generate a one-time PIN and tell it to the customer.',
  'admin.camps.pin_copied':'COPIED',
  'admin.camps.pin_tap':   'TAP TO COPY',
  'admin.camps.pin_until': 'Until {time} (15 min)',
  'admin.camps.pin_new':   'Generate new',
  'admin.camps.pin_create':'Create PIN',
  'admin.camps.pin_gen':   'Generating...',

  'admin.topup.balance':    'Current balance',
  'admin.topup.forecast':   'Forecast',
  'admin.topup.amount':     'Top-up amount',
  'admin.topup.unit':       'UZS',
  'admin.topup.transfer':   'Transfer amount',
  'admin.topup.before_fee': 'GEO (before fee)',
  'admin.topup.fee':        'Fee 10%',
  'admin.topup.you_get':    'You get',
  'admin.topup.acts_approx':'≈ {count} campaign activations',
  'admin.topup.min':        'Minimum top-up: 10 000 UZS',
  'admin.topup.submitting': 'Creating request...',
  'admin.topup.btn':        'Top up — {uzs} UZS',
  'admin.topup.enter':      'Enter amount',
  'admin.topup.history':    'Top-up history',
  'admin.topup.empty':      'No top-ups yet',

  'admin.qr.hint':    'Place the QR at your venue. Customers scan and earn GEO bonuses on check-in.',
  'admin.qr.info':    'Venue information',
  'admin.qr.name':    'Name',
  'admin.qr.address': 'Address',
  'admin.qr.balance': 'Balance',

  'admin.panel':          'Business panel',
  'admin.notowner.title': 'Business panel',
  'admin.notowner.text':  'You are not registered as a venue owner.\n\nContact GeoEarn admin to get connected.',

  'admin.day.one':  'day',
  'admin.day.few':  'days',
  'admin.day.many': 'days',

  // TOS screen
  'tos.title':                   'User Agreement',
  'tos.subtitle':                'Read the key terms before using GeoEarn',
  'tos.point1':                  'You earn GEO by visiting venues and participating in campaigns.',
  'tos.point2':                  'Using bots, faking GPS, or creating multiple accounts is prohibited.',
  'tos.point3':                  'GEO are not securities. The conversion rate may change.',
  'tos.point4':                  'We collect Telegram account data for authorization and fraud prevention.',
  'tos.terms':                   'Terms of Service',
  'tos.privacy':                 'Privacy Policy',
  'tos.checkbox':                'I have read and accept the GeoEarn Terms of Service and Privacy Policy',
  'tos.saving':                  'Saving…',
  'tos.accept':                  'Accept and Start',
  'tos.version':                 'Agreement version: {v} · {year}',

  // Profile
  'profile.sa.sub':              'Control Panel',
  'profile.partner.title':       'Become a Partner',
  'profile.partner.sub':         'Apply for a business account',

  // Browser gate
  'gate.text':                   'This app only works inside Telegram.\nOpen the bot and scan the QR code there.',
  'gate.btn':                    'Open @geoearnbot',
  'gate.hint':                   'or find @geoearnbot in Telegram search',

  // Business apply page
  'apply.title':                 'Become a Partner',
  'apply.intro':                 'Fill out the form — we will review your application and contact you via Telegram. After approval you will get access to the business panel and can create campaigns.',
  'apply.success.title':         'Application submitted!',
  'apply.success.sub':           'We will notify you via Telegram when your application is reviewed.',
  'apply.form.name':             'Venue name',
  'apply.form.name_ph':          'e.g. Cozy Café',
  'apply.form.location':         'Location',
  'apply.form.pick_map':         'Pin on map',
  'apply.form.address_label':    'Address (text)',
  'apply.form.address_ph':       'Auto-filled or enter manually',
  'apply.form.address_hint':     'Or enter the address manually',
  'apply.form.category':         'Category',
  'apply.form.no_cat':           '— not selected —',
  'apply.form.phone':            'Contact phone',
  'apply.form.phone_hint':       'For communication about the application',
  'apply.form.submit':           'Submit application',
  'apply.form.submitting':       'Submitting…',
  'apply.err.name':              'Enter the venue name',
  'apply.err.owner':             'You already have a business account',
  'apply.err.pending':           'Application already submitted and pending review',
  'apply.err.generic':           'Error submitting application. Please try again.',
  'apply.err.conn':              'No connection. Please try again.',
  'apply.reapply':               'Reapply',
  'apply.status.pending.title':  'Application under review',
  'apply.status.pending.sub':    'We are reviewing your application. This usually takes 1–2 business days.',
  'apply.status.approved.title': 'Application approved!',
  'apply.status.approved.sub':   'Your business account is activated. Go to the Business section.',
  'apply.status.rejected.title': 'Application rejected',
  'apply.status.rejected.sub':   'Contact support to find out the reason.',
  'apply.status.info':           'Application #{id} · {date}',
  'apply.map.title':             'Mark the location',
  'apply.map.hint':              'Tap the map or drag the pin',
  'apply.map.no_pos':            'No location selected',
  'apply.map.geocoding':         'Resolving address…',
  'apply.map.confirm':           'Confirm location',
  'apply.cat.cafe':              'Café / Restaurant',
  'apply.cat.shop':              'Shop',
  'apply.cat.pharmacy':          'Pharmacy',
  'apply.cat.beauty':            'Beauty salon',
  'apply.cat.gym':               'Gym / Fitness',
  'apply.cat.auto':              'Auto service',
  'apply.cat.other':             'Other',

  // Checkin — geohunt & milestone
  'checkin.geohunt.found':       'GeoHunt found!',
  'checkin.geohunt.activating':  'Activating GeoHunt…',
  'checkin.geohunt.checking':    'Verifying code…',
  'checkin.milestone.streak':    'DAYS STREAK',
  'checkin.milestone.bonus':     'Milestone bonus credited!',
  'checkin.milestone.continue':  'Continue',

  // Home extra
  'home.section.nearby':         'Near you',
  'home.no_camps_yet':           'No campaigns yet',
  'home.venues_soon':            'Venues will appear once partners add them',
  'home.open_maps':              'Open in Google Maps',
  'home.load_err':               'Failed to load campaigns',
  'home.retry':                  'Retry',

  'home.platform_promo':     'Platform offer',

  // GeoHunt sheet
  'home.hunt.reward_label':  'Reward per code',
  'home.hunt.progress':      'Progress',
  'home.hunt.remaining':     '{n} remaining',
  'home.hunt.all_found':     'All found',
  'home.hunt.found_of':      '{found} of {total} found · {pct}%',
  'home.hunt.scanned_of':    '{found}/{total} scanned · {remaining} remaining',
  'home.hunt.find_on_map':   'Find QR codes on map',
  'home.geo_per_code':       'GEO/ea',

  // Promo QR sheet
  'home.promo.availability': 'Availability',
  'home.promo.available':    '{n} available',
  'home.promo.exhausted':    'Exhausted',
  'home.promo.claimed_of':   '{claimed} of {total} claimed',
  'home.promo.get_reward':   'Get reward',
};

export const translations = { ru, uz, en };

// Parse bilingual task_description field.
// Stored as JSON {"ru":"...","uz":"..."} or legacy plain string.
export function parseTaskDesc(raw, lang) {
  if (!raw) return '';
  try {
    const obj = JSON.parse(raw);
    if (obj && typeof obj === 'object') {
      return obj[lang] || obj.ru || obj.uz || '';
    }
  } catch { /* not JSON */ }
  return raw;
}

export function pluralize(lang, n, one, few, many) {
  if (lang !== 'ru') return `${n} ${n === 1 ? one : (many || few)}`;
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} ${one}`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return `${n} ${few}`;
  return `${n} ${many}`;
}

export function getTranslator(lang) {
  const dict = translations[lang] || translations.ru;
  return function t(key, vars = {}) {
    let str = dict[key] ?? translations.ru[key] ?? key;
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
    return str;
  };
}
